import React from "react";
import "./styles.scss";
import { GetIconByName } from "../../config/icon";

const Index = ({ data, onClickBack }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`navigation-wrapper ${data.type} ${data.size} ${data.mainLayerStyles}`}
      >
        <div className={"nw__icon"} onClick={onClickBack}>
          {GetIconByName(data.icon)}
        </div>
        <div className={"nw__title"}>{data.title}</div>
      </div>
    </>
  );

  return (
    <>
      <>{inputElement}</>
    </>
  );
};

export default Index;
